import ApiService from '@/core/connector/api.service';
import TracksServices from '@/modules/contract/services/tracks.services';
import router from '@/router';

export default class ActivityService extends ApiService {
  constructor(props) {
    super(props);
    this.url = 'sg';
  }

  setLoader() {
    this.loader = false;
  }

  async record(uniqueId, activity) {
    try {
      const infos = await new TracksServices().fetch();
      if (infos) {
        this.url = `${this.url}/document_contacts/activity/${uniqueId}`;
        this.payload = { infos, activity_id: activity };
        await this.post();
      }
    } catch (e) {
      router.push({
        name: 'TrackerInfo',
      });
    }
  }
}
